import { Component, Vue } from 'vue-property-decorator';
import { UiComponentPrimaryClickAction } from '@/enums/UiComponentPrimaryClickAction';

@Component
export default class UiComponentPrimaryClickActions extends Vue {
  get uiComponentPrimaryClickActions() {
    return [{ text: this.$t('venue.form.externalDeliveryService.link'), value: UiComponentPrimaryClickAction.LINK }];
  }
}
